import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TicaretSection = ({ title, description, isReversed = false, image }) => (
  <div className={`flex flex-col md:flex-row items-center gap-8 py-16 ${isReversed ? 'md:flex-row-reverse' : ''}`}>
    <div className="w-full md:w-1/2 space-y-4">
      <h3 className="text-2xl md:text-3xl font-semibold text-gray-900">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
    <div className="w-full md:w-1/2 h-64 md:h-96 bg-gray-200 rounded-lg overflow-hidden">
      <img 
        src={image} 
        alt={title} 
        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
      />
    </div>
  </div>
);

const Ticaret = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative h-[60vh] bg-primaryNavy">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(/images/trade.jpg)',
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              {t('ticaret.hero.title')}
            </h1>
            <p className="text-lg md:text-xl text-white/90">
              {t('ticaret.hero.description')}
            </p>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">
        <TicaretSection
          title={t('ticaret.overview.title')}
          description={t('ticaret.overview.description')}
          image="/images/global-trade.jpg"
        />
        <div className="border-t border-gray-200" />
        <TicaretSection
          title={t('ticaret.services.title')}
          description={t('ticaret.services.description')}
          image="/images/customs.jpg"
          isReversed={true}
        />
      </div>
    </div>
  );
};

export default Ticaret; 